<template>
    <div class="copy-wrapper">
        <button
            type="button"
            aria-label="copy number"
            @click="copyToClipboard(copyText)"
            class="badge-container-orange"
        >
            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                    <path d="M4.99999 1.25H0.749999C0.335786 1.25 0 1.58579 0 2V6.24999C0 6.66421 0.335786 6.99999 0.749999 6.99999H4.99999C5.41421 6.99999 5.74999 6.66421 5.74999 6.24999V2C5.74999 1.58579 5.41421 1.25 4.99999 1.25Z" fill="white"/>
                    <path d="M6.25001 4.8428e-10H1.75001C1.33804 -1.46479e-05 1.00318 0.332285 1.00002 0.744243C1.00002 0.74625 1.00002 0.747993 1.00002 0.75H5.00002C5.69003 0.75082 6.24919 1.30998 6.25001 1.99999V6C6.25202 6 6.25376 6 6.25577 6C6.66774 5.99683 7.00003 5.66197 7.00001 5.25V0.75C7.00001 0.335786 6.66423 4.8428e-10 6.25001 4.8428e-10Z" fill="white"/>
                </g>
                <defs>
                    <clipPath id="clip0">
                        <rect width="7" height="7" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
            <span class="copy--alt">{{ translate("ui.copy.btn", "Copy")}}</span>
        </button>
        <span v-if="showCopied" id="copy-message" class="copy-message">
            {{ translate("ui.copy.text", "Copied!")}}
        </span>
    </div>
</template>
<script>
import { toClipboard } from "@soerenmartius/vue3-clipboard";
import { ref } from "vue";
export default {
    name: "CopyButton",
    props: {
        copyText: {
            type: String,
            required: true,
        },
    },
    setup(){
        const showCopied = ref(false);
        function copyToClipboard(data) {
            toClipboard(data);
            showCopied.value = true;
            setTimeout(() => {
                showCopied.value = false;
            }, 700);
        }
        return{
            showCopied,
            copyToClipboard,
        };
    },
};
</script>
<style lang="scss" scoped>
.copy-message {
  margin-left: .7rem;
  font-size: 1.4rem;
  line-height: 1.3rem;
  color: #a6a6a6;
  position: absolute;
  animation: fade 0.2s ease;
  right: -90%;
}
.copy-wrapper{
  display: flex;
  position: relative;
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.badge-container-orange {
  border: none;
  background: $primary-color;
  color: $white;
  border-radius: .3rem;
  display: inline-block;
  margin-left: 1.2rem;
  font-weight: $font-medium;
  font-size: .8rem;
  font-weight: bold;
  max-width: 4.95rem;
  width: 100%;
  line-height: 105%;
  text-transform: uppercase;
  padding: .5rem .6rem;
  margin: 0 0 0 1.5rem;
  cursor: pointer;
  .copy--alt {
    padding-left: .5rem;
  }
}
</style>